export const DE_LANG = {
    FRAGEBOEGEN_APP: {
        APP_NAME: 'Fragebögen zur steuerlichen Erfassung',
        FRAGEBOEGEN_TYP: {
            EUN: 'Aufnahme einer gewerblichen Tätigkeit',
            PERS_GES: 'Gründung einer Personengesellschaft',
            KAP_GES: 'Gründung einer Kapitalgesellschaft',
            BETPG: 'Beteiligung an einer Personengesellschaft',
            KAPG_AUS: 'Körperschaft nach ausländischem Recht'
        },
        GLOBAL_ERROR: {
            TITLE: 'Es ist ein Fehler aufgetreten',
            MESSAGE: 'Bitte versuchen Sie es zu einem späteren Zeitpunkt erneut.',
            SECONDMESSAGE: '',
            ZUR_UEBERSICHT: 'Zur Übersicht'
        },
        NOT_FOUND_ERROR: {
            TITLE: '404: Seite nicht gefunden',
            MESSAGE: 'Seite wurde nicht gefunden. Bitte versuchen Sie eine anderre Adresse'
        },
        FORBIDDEN_ERROR: {
            TITLE: 'Sie haben keine Berechtigung',
            MESSAGE: 'Für eine Freischaltung in der Rechteverwaltung online beachten Sie bitte folgendes Dokument ',
            SECONDMESSAGE: ' oder wenden Sie sich an Ihren Administrator. [Fehlercode: {{status}}]',
            TITLE_QUESTIONNAIRE: 'Aufruf fehlgeschlagen',
            MESSAGE_QUESTIONNAIRE: 'Der gewünschte Fragebogen kann nicht geöffnet werden, da er mit einem anderen ' +
                'Fragebogentyp angelegt wurde oder der gewünschte Fragebogentyp noch nicht zur Verfügung steht.',
            BACK_TO_LANDINGPAGE: 'Zurück zur Übersicht',
            BACK_TO_QUESTIONNAIRE: 'Zurück zum Fragebogen',
            MESSAGE_CONJUNCT: 'oder'
        },
        NAVAILABLE: {
            TITLE: 'Entschuldigung, hier ist etwas schief gelaufen.',
            MESSAGE: 'Laden Sie die Seite erneut oder versuchen Sie es später noch einmal.',
            SECONDMESSAGE: 'Weitere Informationen zu Störungen finden Sie unter',
            BACK_TO_LANDINGPAGE: 'Seite neu laden'
        },
        LICENSE: {
            TITLE: 'Nutzungsbedingungen für Fragebögen zur steuerlichen Erfassung'
        },
        UEBERSICHT: {
            TITLE: 'Übersicht',
            INFOBOX: 'Bitte beachten Sie: Die Neuanlage eines Fragebogens ist nur über den DATEV-Arbeitsplatz im Mandantenkontext möglich.',
            OFFENE_ANTRAEGE_TITLE: 'Fragebogen-Entwürfe',
            OFFENER_ANTRAG_TITLE: 'Fragebogen-Entwurf',
            OFFENE_ANTRAEGE_TEXT: 'Diese Fragebögen wurden noch nicht erfolgreich an die Finanzverwaltung übermittelt.',
            GESENDETE_ANTRAEGE_TITLE: 'übermittelte Fragebögen',
            GESENDETER_ANTRAG_TITLE: 'übermittelter Fragebogen',
            GESENDETE_ANTRAEGE_TEXT: 'Diese Fragebögen wurden erfolgreich an die Finanzverwaltung übermittelt.',
            GESENDETE_ANTRAEGE_TRANSFER_DATE: 'Übermittelt am:',
            KEINE_ANTRAEGE: 'Keine Fragebögen vorhanden',
            BEARBEITEN: 'Bearbeiten',
            SUCHE: 'Suchbegriff(e) eingeben',
            SUCHE_HILFE_TEXT: 'Keine Ergebnisse für „{{value}}” gefunden',
            SUCHE_HINT_TEXT: 'Passen Sie Ihre Suche an, um das zu finden, was Sie suchen.',
            TOOLTIP_ERROR: 'Fehler bei der Übermittlung',
            TOOLTIP_SENDING: 'Übermittlung läuft'
        },
        HELP: 'Hilfe',
        UMSTELLUNG_2020: {
            MESSAGE: 'Die DATEV Fragebögen zur steuerlichen Erfassung werden demnächst auf die Version 2020 ' +
                'umgestellt. Wir empfehlen Ihnen, Ihre Fragebögen-Entwürfe zeitnah zu übermitteln, ' +
                'um eine reibungslose Umstellung zu ermöglichen.',
            LINK: 'Aktuelle Version von DATEV Fragebögen zur steuerlichen Erfassung'
        }
    },
    relogin: {
        started: {
            header: 'Automatisch abgemeldet',
            body: 'Sie wurden wegen Inaktivität zur Sicherheit abgemeldet.',
            footer: 'Erneut anmelden'
        },
        pending: {
            body: 'Sie werden neu angemeldet ...'
        },
        error: {
            header: 'Anmeldung fehlgeschlagen!',
            body: {
                label1: 'Sie konnten nicht erneut angemeldet werden.',
                label2: 'Bitte starten Sie die Anwendung neu.'
            },
            footer: 'Schließen'
        }
    },
  'pdf-viewer': {
    close: 'Schließen',
    showDetails: 'Dokumentendetails ein-/ausblenden'
  },
  'pdf-controls': {
    prevPage: 'Vorherige Seite des Dokuments',
    page: 'Seite',
    pageInput: 'Seitenzahl',
    of: 'von',
    nextPage: 'Nächste Seite des Dokuments',
    decZoom: 'Darstellung verkleinern',
    chooseZoom: 'Zoomstufe auswählen',
    'page-fit': 'Seitenhöhe',
    'page-width': 'Seitenbreite',
    incZoom: 'Darstellung vergrößern',
    rotLeft: 'Dokument nach links rotieren',
    rotRight: 'Dokument nach rechts rotieren',
    download: 'Dokument herunterladen'
  },
  'pdf-navigation': {
    prevDoc: 'Vorheriges Dokument',
    document: 'Dokument',
    nextDoc: 'Nächstes Dokument'
  }
};
